<label>{{field.templateOptions?.label}}</label> - <a href="#"> <i class="fa fa-plus link-primary"></i></a>
@if (externalLinkUrl) {
    <a style="margin-left:2pt" [href]="externalLinkUrl" target="_blank"> <i
        class="fa fa-external-link link-primary"></i></a>
}
<p>{{ check() }}</p>
